import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Flex from '../../atoms/Flex';
import { readableNumberParts } from '../../../helpers/Numbers';
import ClaimTableRow from '../../molecules/table/ClaimTableRow';
import { readableDateTime } from '../../../helpers/Date';
import ClaimTableHeader from '../../molecules/table/ClaimTableHeader';
const ClaimTable = ({ claim }) => {
    const items = {
        Aanslagbiljetnummer: claim.notice_number,
        'Soort invordering': claim.type,
        'Datum/tijd van de vordering': readableDateTime(claim.offence_date),
        Aanslagbedrag: claim.assessment_costs
            ? readableNumberParts(claim.assessment_amount, 'EUR').longDecimal
            : null,
        Aanslagkosten: claim.assessment_costs
            ? readableNumberParts(claim.assessment_costs, 'EUR').longDecimal
            : null,
        Heffingsbedrag: claim.head_sum
            ? readableNumberParts(claim.head_sum, 'EUR').longDecimal
            : null,
        Kenteken: claim.licence_plate,
        'Merk voertuig': claim.vehicle_brand,
        'Kleur voertuig': claim.vehicle_color,
        'Plaats constatering': claim.offence_place,
        'Gemeente constatering': claim.offence_municipality,
        'Belastbaar feitcode': claim.offence_code,
        'Belastbaar feit toevoeging': claim.offence_description,
        'ID handhaving': claim.enforcer_id,
    };
    return (_jsxs(Flex, { column: true, children: [_jsx(ClaimTableHeader, { title: "Gegevens vordering" }), Object.keys(items)
                .filter(label => items[label])
                .map(label => (_jsx(ClaimTableRow, { noHover: true, label: label, value: items[label] || '' }, label)))] }));
};
export default ClaimTable;
